module.exports = __webpack_public_path__ + "static/media/KellyNolan.5cbcbe4a.jpeg";